import { useEffect } from 'react'
import { useScheduleStore } from '@/store/useScheduleStore'
import { useLocation } from 'react-router-dom'

export const AppReady = () => {
  const pathname = useLocation().pathname
  useEffect(() => {
    const flowStart = useScheduleStore.getState().flowStart

    if (pathname.includes('erro-generico') || flowStart) {
      return
    }

    const setScheduleData = useScheduleStore.getState().setScheduleData

    setScheduleData('flowStart', true)
  }, [pathname])

  return null
}
